module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAARCAYAAADQWvz5AAAABHNCSVQICAgIfAhkiAAAALZJREFUOI2d09ERhCAMBNCNbVgJ1GElZx9XCXVIJdSx9xNmIkcQ5I8xeS4GheQHQIS/LhH5Dp4DAIRkqg1OTQQAETmGEsmkqZ5qCsng1WxOY7C4pskAkou1iczbS5tilOyWSMEA4BCRXVOcM8nao2VtyLq/0AzBw7amKNdkOs0TndXDKhRN0W56Du8O/WE6oWLu09LSAaS6eYXpJyi3e7iKdZFVbIjMYlPIE7aEeNgrpAHtv+ciP3BaE/Cz1ohsAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/Stoudititle.png
// module id = pwFW
// module chunks = 1